import { sendGetRequest, sendPostRequest } from "services/apiService";

export type UserForceMovePayload = {
  eventId: string;
  targetFloorId: string;
  targetTableId: string;
  currentTableId: string;
  userId: string;
  currentFloorId: string;
};

export type Tables = {
  code: string;
  id: string;
  name: string;
  occupiedSeats: number;
};

export type SpacesResponse = {
  floorCapacity: number;
  occupiedSeats: number;
  tables: Tables[];
};

type GetSpacesResponse =
  | {
      status: false;
      reason?: string;
      message?: string;
    }
  | {
      status: true;
      spaces: Record<string, SpacesResponse>;
    };

type SwitchTableResponse =
  | {
      status: false;
      reason?: string;
      message?: string;
    }
  | {
      status: true;
    };

export const userForceMove = async (data: UserForceMovePayload) => {
  const { eventId, ...payload } = data;
  const resp = await sendPostRequest<
    Omit<UserForceMovePayload, "eventId">,
    SwitchTableResponse
  >(`/event/${eventId}/user/force-move`, payload);

  if (!resp.status) {
    throw new Error(resp?.reason ?? resp?.message);
  }

  return resp;
};

export const getSpacesData = async (eventId: string, theaterId: string) => {
  const resp = await sendGetRequest<GetSpacesResponse>(
    `/event/${eventId}/${theaterId}/spaces`,
  );

  if (!resp.status) {
    throw new Error(resp?.reason ?? resp?.message);
  }

  return resp;
};
